/**
 * @auth 赖传峰
 * @date 2024/1/29
 */

import { SupportLocale } from './types/enum'

const DEFAULT_LOCALE = SupportLocale.EN_US

// @ts-ignore
export default defineI18nConfig(() => ({
  legacy: false,
  locale: DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE,
  warnHtmlMessage: false,
  fallbackWarn: false,
}))
